module.exports = __webpack_public_path__ + "static/media/site-name.0b9086c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/06-assets/images/home/site-name.png
// module id = 261
// module chunks = 0